(() => {
  const RELEASIT_CART_ACTION_SELECTOR = [
    '._rsi-buy-now-button-cart',
    '#_rsi-buy-now-button._rsi-buy-now-button-cart',
    '#_rsi-buy-now-button-overwrite._rsi-buy-now-button-cart',
  ].join(',');

  const SHOPIFY_CHECKOUT_ACTION_SELECTOR = [
    '#checkout',
    '.cart__checkout-button',
    'a[href="/checkout"]',
    'a[href^="/checkout?"]',
    'button#cart-checkout',
    'button#cart-sidebar-checkout',
  ].join(',');

  const pendingActions = new WeakSet();

  const checkoutStyle = document.createElement('style');
  checkoutStyle.textContent = `
    .additional-checkout-buttons,
    shopify-accelerated-checkout,
    .shopify-payment-button,
    a[href="/checkout"],
    a[href^="/checkout?"] {
      display: none !important;
    }
  `;
  document.head.append(checkoutStyle);

  /**
   * @param {Element} element
   * @returns {boolean}
   */
  const isVisible = (element) => {
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  };

  /**
   * @param {ParentNode} scope
   * @returns {HTMLElement | null}
   */
  const findReleasitAction = (scope) => {
    for (const element of scope.querySelectorAll(RELEASIT_CART_ACTION_SELECTOR)) {
      if (element instanceof HTMLElement && isVisible(element)) return element;
    }
    return null;
  };

  /**
   * @param {ParentNode} scope
   * @returns {Promise<HTMLElement | null>}
   */
  const waitForReleasitAction = (scope) =>
    new Promise((resolve) => {
      const existingAction = findReleasitAction(scope);
      if (existingAction) {
        resolve(existingAction);
        return;
      }

      const observer = new MutationObserver(() => {
        const action = findReleasitAction(scope);
        if (!action) return;
        observer.disconnect();
        window.clearTimeout(timeout);
        resolve(action);
      });

      observer.observe(scope, { childList: true, subtree: true, attributes: true });

      const timeout = window.setTimeout(() => {
        observer.disconnect();
        resolve(findReleasitAction(scope));
      }, 8000);
    });

  /**
   * @param {HTMLElement} source
   */
  const openReleasitCheckout = async (source) => {
    if (pendingActions.has(source)) return;

    pendingActions.add(source);
    source.setAttribute('aria-busy', 'true');

    try {
      const drawer = source.closest('theme-drawer#cart-drawer');
      const scope = drawer || document;
      const action = findReleasitAction(scope) || (await waitForReleasitAction(scope));

      if (action) {
        action.click();
        return;
      }

      window.alert('Le formulaire de commande est en cours de chargement. Veuillez réessayer dans quelques secondes.');
    } finally {
      pendingActions.delete(source);
      source.removeAttribute('aria-busy');
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;
      const action = event.target.closest(SHOPIFY_CHECKOUT_ACTION_SELECTOR);
      if (!(action instanceof HTMLElement)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      openReleasitCheckout(action);
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const submitter = event.submitter;
      const action = event.target instanceof HTMLFormElement ? event.target.action : '';
      const isShopifyCheckout =
        (submitter instanceof Element && submitter.matches(SHOPIFY_CHECKOUT_ACTION_SELECTOR)) ||
        /\/checkout(?:[/?]|$)/i.test(action);

      if (!isShopifyCheckout) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      openReleasitCheckout(submitter instanceof HTMLElement ? submitter : event.target);
    },
    true
  );
})();
